module.exports = __webpack_public_path__ + "static/OrbitalLogo400x173.fe72903a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/OrbitalLogo400x173.png
// module id = 501
// module chunks = 79718873386587